export default "__VITE_ASSET__Db0Y2F3W__"